import { useCallback, useState } from 'react';

import { NetworkScan, Pagan } from './types';
import { ApiConfig, useApi } from './useApi';

export function useNetworkScans(config: ApiConfig = {}) {
  const api = useApi(config);
  const [scans, setScans] = useState<NetworkScan[]>([]);
  const [pagans, setPagans] = useState<Pagan[]>([]);

  const fetchScans = useCallback(
    async (subnetId: number) => {
      try {
        const response = await api.get<NetworkScan[]>(
          `/subnets/${subnetId}/scans/`,
        );
        setScans(response);
        return response;
      } catch (error) {
        console.error('Failed to fetch network scans:', error);
        throw error;
      }
    },
    [api],
  );

  const fetchPagans = useCallback(
    async (scanId: number) => {
      try {
        const response = await api.get<Pagan[]>(`/scans/${scanId}/pagans/`);
        setPagans(response);
        return response;
      } catch (error) {
        console.error('Failed to fetch pagans:', error);
        throw error;
      }
    },
    [api],
  );

  const convertPaganToDuck = useCallback(
    async (paganId: number, name: string, tagIds: number[]) => {
      try {
        const response = await api.post<{ duck_id: number }>(
          `/pagans/${paganId}/convert/`,
          {
            name,
            tag_ids: tagIds,
          },
        );
        return response;
      } catch (error) {
        console.error('Failed to convert pagan to duck:', error);
        throw error;
      }
    },
    [api],
  );

  return {
    scans,
    pagans,
    loading: api.loading,
    error: api.error,
    fetchScans,
    fetchPagans,
    convertPaganToDuck,
  };
}
